import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { OverclaimBulkRelinquishment } from '@Entities/overclaim/overclaim-bulk-relinquishment'
import Pluralize from 'pluralize'
import { OverclaimBulkActionType } from '@App/stores/overclaim/overclaim-search-bulk-action-store'

interface BulkRelinquishmentSubmittedPopupProps {
    bulkRelinquishmentResults?: OverclaimBulkRelinquishment
    onCancel: () => Promise<void>
    totalWorks?: number
}

const BulkRelinquishmentSubmittedPopup = (props: BulkRelinquishmentSubmittedPopupProps) => {
    const { overclaimSearchBulkActionStore } = useContext(StoresContext)
    const { bulkRelinquishmentResults, onCancel, totalWorks } = props
    return (
        <>
            {bulkRelinquishmentResults?.failed.length === 0 ? (
                <ConfirmationPopup
                    title="Request Submitted"
                    popupClassName="bulk-relinquishment-success-popup"
                    onConfirm={() => {
                        onCancel().then(() => {
                            overclaimSearchBulkActionStore.setActiveBulkAction(null)
                        })
                    }}
                    onCancel={() => {
                        onCancel().then(() => {
                            overclaimSearchBulkActionStore.setActiveBulkAction(OverclaimBulkActionType.Relinquishment)
                        })
                    }}
                    cancelButtonText="Start another relinquishment"
                    confirmButtonText="Return to Overclaims Tool"
                >
                    {totalWorks} works requested for bulk relinquishment
                </ConfirmationPopup>
            ) : (
                <ConfirmationPopup
                    title="Bulk Relinquishment Submitted"
                    popupClassName="bulk-relinquishment-fail-popup"
                    onConfirm={onCancel}
                    confirmButtonText="Done"
                >
                    <div className="submission-error-body">
                        <div>
                            <b>{Pluralize('work', bulkRelinquishmentResults?.succeededCount, true)}</b> <b>submitted</b>{' '}
                            for relinquishment.
                            <br />
                            <b>{Pluralize('work', bulkRelinquishmentResults?.failed.length, true)}</b> <b>failed</b> to
                            be relinquished.
                        </div>
                        <p className="song-code-list">
                            MLC Song Codes that failed:
                            <br />
                            {bulkRelinquishmentResults?.failed.join(', ')}
                        </p>
                        <p style={{ fontSize: '2.4rem' }}>
                            Some of the works weren't relinquished successfully. Click 'Done' and try running your
                            search again in 24 hours. The failed relinquishments will still be accessible.
                        </p>
                    </div>
                </ConfirmationPopup>
            )}
        </>
    )
}
export default BulkRelinquishmentSubmittedPopup
